<template>
  <div id="app" class="app-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
.app-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
